import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import BreadCrumb from "../components/BreadCrumb";
import { HiOutlineArrowLeft } from "react-icons/hi";
import Meta from "../components/Meta";
import blog from "../images/blog-1.jpg";
import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
import { getABlog } from "../features/blogs/blogSlice";

const SingleBlog = () => {
  const blogState = useSelector((state) => state?.blog?.singleblog);
  const location = useLocation();
  const getBlogId = location.pathname.split("/")[2];

  const dispatch = useDispatch();
  useEffect(() => {
    getblog();
  }, []);
  const getblog = () => {
    dispatch(getABlog(getBlogId));
  };

  // Schema markup for structured data
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://vedamerchandise.com/blog/${getBlogId}`
    },
    "headline": blogState?.title,
    "description": blogState?.description?.replace(/<[^>]*>/g, '').substring(0, 160),
    "image": blogState?.images?.map(img => img.url),
    "author": {
      "@type": "Organization",
      "name": "VEDA Merchandise"
    },
    "publisher": {
      "@type": "Organization",
      "name": "VEDA Merchandise",
      "logo": {
        "@type": "ImageObject",
        "url": "https://vedamerchandise.com/logo.svg"
      }
    },
    "datePublished": blogState?.createdAt,
    "dateModified": blogState?.updatedAt
  };

  return (
    <>
      <Meta 
        title={`${blogState?.title} - VEDA Blog`}
        description={blogState?.description?.replace(/<[^>]*>/g, '').substring(0, 160) || "Read this interesting blog post from VEDA."}
        keywords={`${blogState?.title}, mythology blog, Indian mythology, educational content, VEDA`}
        author="VEDA Merchandise"
        ogTitle={`${blogState?.title} - VEDA Blog`}
        ogDescription={blogState?.description?.replace(/<[^>]*>/g, '').substring(0, 160) || "Read this interesting blog post from VEDA."}
        ogImage={blogState?.images?.[0]?.url || "https://vedamerchandise.com/blog-preview.jpg"}
        ogUrl={`https://vedamerchandise.com/blog/${getBlogId}`}
        ogType="article"
        twitterCard="summary_large_image"
        twitterTitle={`${blogState?.title} - VEDA Blog`}
        twitterDescription={blogState?.description?.replace(/<[^>]*>/g, '').substring(0, 160) || "Read this interesting blog post from VEDA."}
        twitterImage={blogState?.images?.[0]?.url || "https://vedamerchandise.com/blog-preview.jpg"}
        robots="index, follow"
        canonicalUrl={`https://vedamerchandise.com/blog/${getBlogId}`}
        schemaMarkup={schemaMarkup}
      />
      <Container class1="blog-wrapper home-wrapper-2 py-5">
        <div className="row">
          <div className="col-12">
            <div className="single-blog-card">
              <Link to="/blogs" className="d-flex align-items-center gap-10">
                <HiOutlineArrowLeft className="fs-4" /> Go back to Blogs
              </Link>
              <h3 className="title">{blogState?.title} </h3>
              <img src={blog} className="img-fluid w-100 my-4" alt="blog" />
              <p
                dangerouslySetInnerHTML={{ __html: blogState?.description }}
              ></p>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default SingleBlog;